"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = void 0;
var React = require("react");
var styled_components_1 = require("styled-components");
var Keyboard_1 = require("../../_Core/Keyboard");
var Localization_1 = require("../../Localization");
var Theme_1 = require("../../Theme");
var StyledTextArea = styled_components_1.default.textarea(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    resize: none;\n    padding: ", ";\n    font-size: ", ";\n    background-color: white;\n    border: 1px solid ", ";\n    box-sizing: border-box;\n    line-height: 1.3em\n\n    &[disabled] {\n        opacity: ", ";\n    }\n"], ["\n    width: 100%;\n    resize: none;\n    padding: ", ";\n    font-size: ", ";\n    background-color: white;\n    border: 1px solid ", ";\n    box-sizing: border-box;\n    line-height: 1.3em\n\n    &[disabled] {\n        opacity: ", ";\n    }\n"])), Theme_1.PixelUnit(1), Theme_1.FontSize, Theme_1.Color.Grey.G30, Theme_1.DisabledOpacity);
StyledTextArea.displayName = "StyledTextArea";
var CountArea = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size:10px;\n    margin-top: 0.5em;\n    display:flex;\n\n    > div {\n        flex: 1 1 auto;\n    }\n"], ["\n    font-size:10px;\n    margin-top: 0.5em;\n    display:flex;\n\n    > div {\n        flex: 1 1 auto;\n    }\n"])));
CountArea.displayName = "CountArea";
var AriaLive = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n"], ["\n"])));
AriaLive.displayName = "AriaLive";
var TextArea = /** @class */ (function (_super) {
    __extends(TextArea, _super);
    function TextArea(props) {
        var _this = _super.call(this, props) || this;
        _this.buildAriaLabel = function () {
            if (_this.props.MaxLength) {
                return (_this.props.AriaLabel + ", " + Localization_1.strings.formatString(Localization_1.strings.TextArea_Label_CurrentCount, _this.valueLength(), _this.props.MaxLength));
            }
            return _this.props.AriaLabel;
        };
        _this.handleTextInputKeyDown = function (e) {
            if (Keyboard_1.IsPrintableKey(e.keyCode) && _this.state.Value && (_this.state.Value.length > (_this.props.MaxLength - 1))) {
                e.preventDefault();
                _this.setState({ Announce: Localization_1.strings.TextArea_Messages_MaximumCharacters });
                return false;
            }
            else {
                _this.setState({ Announce: "" });
            }
        };
        _this.handleChange = function (e) {
            if (!_this.props.Disabled && !_this.props.ReadOnly) {
                _this.props.MaxLength ?
                    _this.setState({ Value: e.target.value.substring(0, _this.props.MaxLength) }) :
                    _this.setState({ Value: e.target.value });
                if (_this.props.OnChange) {
                    _this.props.OnChange(e.target.value);
                }
            }
        };
        _this.buildDisplayRow = function () {
            if (_this.props.MaxLength && _this.props.DisplayMaxLengthIndicator) {
                return (React.createElement(CountArea, { key: "count" },
                    React.createElement(AriaLive, { "aria-live": "assertive" }, _this.state.Announce),
                    _this.valueLength(),
                    " of ",
                    _this.props.MaxLength));
            }
        };
        _this.valueLength = function () {
            return (_this.state.Value ? _this.state.Value.length : 0);
        };
        props.MaxLength && props.Value ?
            _this.state = { Value: _this.props.Value.substring(0, props.MaxLength) } :
            _this.state = { Value: _this.props.Value };
        return _this;
    }
    TextArea.prototype.UNSAFE_componentWillReceiveProps = function (props) {
        this.setState({ Value: props.Value });
    };
    TextArea.prototype.render = function () {
        return ([React.createElement(StyledTextArea, { key: "textarea", id: this.props.ID, onKeyDown: this.props.MaxLength ? this.handleTextInputKeyDown : undefined, style: this.props.Height ? { height: this.props.Height } : { height: "200px" }, onChange: this.handleChange, placeholder: this.props.Placeholder, readOnly: this.props.ReadOnly, disabled: this.props.Disabled, "aria-label": this.buildAriaLabel(), value: this.state.Value }), this.buildDisplayRow(),]);
    };
    return TextArea;
}(React.Component));
exports.TextArea = TextArea;
var templateObject_1, templateObject_2, templateObject_3;
